import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

/**
 * Screen 191: Bank reconciliation summary — reconciled PDC items (view_pdc_reminder_reconciled).
 * Uses `id` as bank reconciliation voucher id (br_voucher_id).
 */
export const screen_191_bank_reconciliation_summary: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Bank Reconciliation",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [],
          },
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "br_voucher_no",
            Name: "bank_reconciliation_summary",
            apiname: "bank_reconciliation_summary",
            BindValue: "grid_bank_reconciliation_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/bank_reconciliation_voucher/<id>",
                },
                ActionType: ActionType.EDIT,
                ScreenId: "180",
                Label: "View",
              },
            ],
            Form: {
              Name: "bank_reconciliation_summary",
              TableName: "",
              DisplayName: "Bank reconciliation summary",
              View: "view_pdc_reminder_reconciled",
              Filter:
                "view_pdc_reminder_reconciled.soft_delete=0 ORDER BY view_pdc_reminder_reconciled.voucher_date DESC",
              Workflow: null,
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "BR voucher no.",
                  BindValue: "txt_br_voucher_no",
                  Json_Attribute: "br_voucher_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Voucher date",
                  BindValue: "txt_voucher_date",
                  Json_Attribute: "voucher_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Transaction voucher no.",
                  BindValue: "txt_voucher_no",
                  Json_Attribute: "voucher_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Voucher type",
                  BindValue: "txt_voucher_type",
                  Json_Attribute: "voucher_type",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Transaction type",
                  BindValue: "txt_transaction_type",
                  Json_Attribute: "transaction_type",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Cheque number",
                  BindValue: "txt_cheque_number",
                  Json_Attribute: "cheque_number",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Bank name",
                  BindValue: "txt_bank_name",
                  Json_Attribute: "bank_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Cheque date",
                  BindValue: "txt_cheque_date",
                  Json_Attribute: "cheque_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Narration",
                  BindValue: "txt_remarks",
                  Json_Attribute: "narration",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Amount",
                  BindValue: "txt_amount",
                  Json_Attribute: "amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Party name",
                  BindValue: "txt_party_name",
                  Json_Attribute: "party_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: false,
                  Label: "PDC reminder source id",
                  BindValue: "pdc_reminder_source_id",
                  Json_Attribute: "pdc_reminder_source_id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: false,
                  Label: "",
                  BindValue: "party_ledger_id",
                  Json_Attribute: "party_ledger_id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: false,
                  Label: "BR voucher id",
                  BindValue: "br_voucher_id",
                  Json_Attribute: "br_voucher_id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: false,
                  Label: "Status",
                  BindValue: "txt_status",
                  Json_Attribute: "status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];

